import Immutable from 'immutable';
import { getFilters } from "../config/filters";
import resolveBaseSearchParameters from "./resolveBaseSearchParameters";
export default function resolveSearchParametersFromFilters({
  applyOverrides,
  filters,
  index,
  numHits,
  page,
  sort,
  resolveAlgoliaQueryFilterOverrides = Immutable.Map(),
  featureFlags
}) {
  const searchParameters = resolveBaseSearchParameters({
    additionalFacets: applyOverrides ? applyOverrides.types : Immutable.Set()
  }).setIndex(index).setHitsPerPage(numHits);
  const filtersSearchParameters = getFilters({
    featureFlags
  }).reduce((filterParams, f) => (resolveAlgoliaQueryFilterOverrides.get(f.get('key')) || f.get('resolveAlgoliaQuery') || (({
    params
  }) => params))({
    params: filterParams,
    filters,
    sort
  }), searchParameters);
  return (applyOverrides ? applyOverrides.apply(filtersSearchParameters) : filtersSearchParameters).setPage(page); // Must be last as changing parameters resets page to 0
}